module.exports = __webpack_public_path__ + "7df617f986fa95cf652e4a40d7b138c4.woff2";